import { Grid2 as Grid, Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context.js"
import { AiTypeReviewWidgetCard } from "routes/asset-register/plugins/asset-mapping/ai-type-review/components/ai-type-review-widgets/ai-type-review-widget-card.js"
import { WidgetTotalContent } from "routes/asset-register/plugins/asset-mapping/ai-type-review/components/ai-type-review-widgets/widget-total-content.js"
import noop from "lib/noop"

export function AiTypeReviewWidgets() {
    const { reviewRows = [], filter = "all", setFilter = noop } = useBoundContext()
    const stats = getReviewStats(reviewRows)

    if (reviewRows.length < 1) return null

    return (
        <Stack spacing={1}>
            <Grid container spacing={1} alignItems="stretch" width="100%">
                <Grid size={{ xs: 12, md: 6 }}>
                    <AiTypeReviewWidgetCard item={getRejectedCardDetails()} />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <AiTypeReviewWidgetCard item={getApprovedCardDetails()} />
                </Grid>
            </Grid>
        </Stack>
    )

    function getRejectedCardDetails() {
        return {
            title: "Rejected",
            icon: "mdi:close-circle-outline",
            color: "error",
            iconColor: "error.main",
            iconSize: 28,
            dataCy: "ai-review-rejected",
            outlineColor: "error.main",
            isActive: filter === "rejected",
            onClick: () => handleSelected("rejected"),
            total: <WidgetTotalContent typeCount={stats.rejected.types} assetCount={stats.rejected.assets} />,
            percentage: getPercentage(stats.rejected.types, stats.total),
        }
    }

    function getApprovedCardDetails() {
        return {
            title: "Accepted",
            icon: "mdi:check-circle-outline",
            color: "success",
            iconColor: "success.main",
            iconSize: 28,
            dataCy: "ai-review-accepted",
            outlineColor: "success.main",
            isActive: filter === "approved",
            onClick: () => handleSelected("approved"),
            total: <WidgetTotalContent typeCount={stats.approved.types} assetCount={stats.approved.assets} />,
            percentage: getPercentage(stats.approved.types, stats.total),
        }
    }

    function handleSelected(selected) {
        if (filter === selected) {
            setFilter("all")
            return
        }
        setFilter(selected)
    }
}

function getReviewStats(rows) {
    const stats = {
        total: rows.length,
        approved: { types: 0, assets: 0 },
        rejected: { types: 0, assets: 0 },
    }

    for (const row of rows) {
        const group = stats[row?.reviewStatus]
        if (!group) continue
        group.types += 1
        group.assets += Number(row?.count) || 0
    }

    return stats
}

function getPercentage(typeCount, totalTypes) {
    if (totalTypes < 1) return 0
    return Number(((typeCount / totalTypes) * 100).toFixed(1)) || 0
}
